import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import HeadingLines from "../assets/images/heading-lines.svg";
function TheReality({ data }) {
  return (
    <>
      {data && (
        <section className="about-the-reality">
          <Container>
            <Row>
              <Col md="12">
                <div className="common-header">
                  <img src={HeadingLines} alt="" />
                  <h2>{data.title}</h2>
                  <p
                    className="m-0"
                    dangerouslySetInnerHTML={{ __html: data.description }}
                  ></p>
                </div>
                <div className="stats-container">
                  {data.cards.map((row, index) => (
                    <div className="stat-item" key={'r'+index}>
                      <h3>
                        {row.subtitle}
                        <span>{row.title}</span>
                      </h3>
                      <p>{row.description}</p>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )}
    </>
  );
}
export default TheReality;
